module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-300.09aafa07.svg";